// DeleteMultipleModal.jsx
import React, { useRef, useState } from "react";
import close from "../Components/Images/x-close.png";

const DeleteMultipleModal = ({ open, onClose, ids, onConfirm }) => {
  const modalRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const closeRef = (e) => {
    if (modalRef.current === e.target) {
      onClose();
    }
  };

  const handleDelete = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm(ids); // parent handles API request
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      onClick={closeRef}
      ref={modalRef}
      className={`fixed flex items-center justify-center z-50 inset-0 bg-opacity-30 bg-black/40 ${open ? "block" : "hidden"
        }`}
    >
      <div className="bg-white w-[460px] 2xl:w-[25%] shadow-lg rounded-xl flex flex-col justify-center mx-3 py-5 px-7">
        <div className="flex justify-between gap-3">
          <div>
            <p className="text-[18px] text-[#1D1C1F] font-medium mb-2">
              Delete {ids.length} Accounts?
            </p>
            <p className="text-[#525154] font-normal text-[14px]">
              This action will permanently delete{" "}
              <span className="font-semibold">{ids.length}</span> selected
              accounts from your client list.
            </p>
            <p className='text-[#525154] font-normal text-[14px] mt-2'>(<strong>Note:</strong> You cannot delete an account if a transfer has been made to them)</p>
          </div>
          <img
            className="size-5 mt-1 cursor-pointer"
            src={close}
            alt="close"
            onClick={onClose}
          />
        </div>
        <div className="flex justify-end gap-2 mt-12">
          <button
            className="p-3 rounded-lg w-[30%] border-[1.2px] text-[#525154] text-[14px] border-black/10"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="p-3 rounded-lg font-medium bg-[#FEEDED] text-[#EF4444] text-[14px] w-[30%]"
            onClick={handleDelete}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMultipleModal;
